var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c(
      "h1",
      {
        staticClass: "subtitle has-text-weight-bold has-text-primary is-size-4"
      },
      [_vm._v("\n    Dados Básicos\n  ")]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "columns" }, [
      _c(
        "div",
        { staticClass: "column is-2" },
        [
          _c(
            "sc-field",
            { attrs: { label: "Cep Origem", prop: "origin_zip_code" } },
            [
              _c("sc-input", {
                directives: [
                  {
                    name: "mask",
                    rawName: "v-mask",
                    value: "cep",
                    expression: "'cep'"
                  }
                ],
                attrs: { placeholder: "Digite o cep de origem" },
                nativeOn: {
                  keyup: function($event) {
                    _vm.changZipCode(_vm.fields.origin_zip_code)
                  }
                },
                model: {
                  value: _vm.fields.origin_zip_code,
                  callback: function($$v) {
                    _vm.$set(_vm.fields, "origin_zip_code", $$v)
                  },
                  expression: "fields.origin_zip_code"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "column is-2" },
        [
          _c(
            "sc-field",
            { attrs: { label: "Cep Destino", prop: "destination_zip_code" } },
            [
              _c("sc-input", {
                directives: [
                  {
                    name: "mask",
                    rawName: "v-mask",
                    value: "cep",
                    expression: "'cep'"
                  }
                ],
                attrs: { placeholder: "Digite o cep de destino" },
                model: {
                  value: _vm.fields.destination_zip_code,
                  callback: function($$v) {
                    _vm.$set(_vm.fields, "destination_zip_code", $$v)
                  },
                  expression: "fields.destination_zip_code"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "column is-8" },
        [
          _c(
            "sc-field",
            { attrs: { label: "Tipo de Cotação" } },
            [
              _vm._v("\n        Entrega\n        "),
              _c("sc-switch", {
                attrs: { value: _vm.status },
                on: { input: _vm.toggleCommit }
              }),
              _vm._v("\n        Reversa\n      ")
            ],
            1
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      [_c("sc-additional-information", { attrs: { fields: _vm.fields } })],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-26f13c72", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26f13c72","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-quote/features/freight-quote/components/sc-basic-data/ScBasicData.vue
// module id = null
// module chunks = 